export default "__VITE_ASSET__Gy2VP4Ws__"